/* 
 ------------------------------------------------ Pages Route Configs --------------------------------------------------------
 */

/* Auth related pages */
import LandingPageConfig from './auth/landing-page/landing-page-config';
import CallbackComponentConfig from './auth/callback-component/callback-component-config';
import SilentRenewConfig from './auth/silent-renew/silent-renew-config';
import SignoutCallbackConfig from './auth/signout-callback/signout-callback-config';

/*  Pages */
import NotFoundPageConfig from './not-found-page/not-found-page-config';
import DashboardConfig from './dashboard/dashboard-config';
/* Profile Page */
import ProfilePageConfig from './profile/profile-config';

/* System User Management Pages */
import SystemUsersConfig from './system-user-management/system-user-config';

/* Pharmacy Management Pages */
import PharmacyManagementConfig from './pharmacy-management/pharmacy-management-config';

/* Customer Management Pages*/
import CustomersConfig from './customer-management/customer-config';

/* Order Management */
import OrderListConfig from './order-management/order-management-config';

/* Campaign Management */
import CampaignsConfig from './campaign-management/campaign-management-config';

/* Parameters Management */
import ParametersConfig from './parameter-management/parameter-management-config';

/* Log Management */
import LogsManagementConfig from './log-management/log-management-config';

const pagesConfigs = [
  /* Auth Pages */
  LandingPageConfig,
  CallbackComponentConfig,
  SilentRenewConfig,
  SignoutCallbackConfig,

  /* Other Pages */
  NotFoundPageConfig,
  DashboardConfig,
  ProfilePageConfig,

  /* System User Management */
  SystemUsersConfig,

  /* Pharmacy Management */
  PharmacyManagementConfig,

  /* Customer Management */
  CustomersConfig,

  /* Order Management */
  OrderListConfig,

  /* Campaing Management */
  CampaignsConfig,

  /* Parameters Management */
  ParametersConfig,

  /* Logs Management */
  LogsManagementConfig
];

export default pagesConfigs;
